<div @slideDownUp class="h-full w-full relative flex flex-col">
  <ng-container>
    <div class="flex-1 overflow-hidden">
      <ng-scrollbar #scrollable class="h-full">
        <div class="space-y-5 p-4">
          <div class="m-6 mt-0 block">
            <h4 class="relative border-b border-[#6208ff] text-center text-xs dark:border-gray-800">
              <span class="relative top-2 text-white bg-black px-3 dark:text-[#ededed]">{{ fechaActual | date: 'mediumDate' }}</span>
            </h4>
          </div>
          <ng-container *ngIf="messages">
            <div *ngFor="let message of messages">
              <div
                class="flex items-start gap-3 px-4 sm:px-1 max-w-full overflow-hidden"
                [ngClass]="{ 'justify-end': message.role === 'user' }"
                *ngIf="message.role === 'assistant' || message.role === 'user'"
              >
                <div class="flex-none" [ngClass]="message.role === 'user' ? 'order-2 thumb-user' : 'thumb-assistant'">
                  <ng-container *ngIf="message.role !== 'user'">
                    <img src="../../../../assets/images/juan2.png" class="w-7 h-7 bg-primary rounded-full" alt="" />
                  </ng-container>
                  <ng-container *ngIf="message.role === 'user'">
                    <!-- <icon-user [fill]="true" class="w-7 h-7 text-primary bg-gray-800 rounded-full"></icon-user> -->
                    <img [src]="selectedAvatar" alt="Avatar" class="w-7 h-7 rounded-full" />
                  </ng-container>
                </div>
                <div class="space-y-2">
                  <div class="flex items-center gap-3">
                    <div
                      class="rounded-md bg-black/10 p-4 py-2 text-white bg-gray-800 dark:bg-gray-800"
                      [ngClass]="
                        message.role === 'user' ? 'ltr:rounded-br-none rtl:rounded-bl-none ' : 'ltr:rounded-bl-none rtl:rounded-br-none !bg-primary text-dark'
                      "
                    >
                      <div
                        class="text-sm sm:text-base break-words overflow-hidden max-w-full whitespace-normal"
                        style="word-break: break-word; overflow-wrap: break-word"
                        [innerHTML]="message.content | nl2br"
                      ></div>
                    </div>
                  </div>
                  <div class="text-xs text-black dark:text-white" [ngClass]="{ 'ltr:text-right rtl:text-left': message.role === 'user' }">
                    <!-- {{ message.created_at ? core.formatChatTimestamp(message.created_at) : '' }} -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Loading points -->
            <div *ngIf="loadingConversation" style="text-align: center">
              <span class="animate-spin border-4 border-warning border-l-transparent rounded-full w-10 h-10 inline-block align-middle m-auto mb-10"></span>
            </div>
          </ng-container>
        </div>
      </ng-scrollbar>
    </div>
    <div class="sticky bottom-4 sm:bottom-0 xl:bottom-0 left-0 w-11/12 mx-auto bg-black p-4 sm:p-0 xl:p-0 mb-4 border-t border-gray-800">
      <div class="w-full items-center space-x-3 rtl:space-x-reverse sm:flex">
        <!-- Botón de prueba -->
        <!-- <button class="btn btn-primary mb-2" (click)="openRegistrationModal()">Abrir Modal Registro</button> -->
        <div class="relative flex-1">
          <textarea
            [(ngModel)]="textMessage"
            class="form-input rounded-full border-0 bg-black text-primary px-6 py-3 pr-16 focus:outline-none w-full resize-none overflow-hidden min-h-[40px] max-h-[80px]"
            placeholder="{{ loadingConversation ? 'El asistente está escribiendo...' : 'Escribe aquí...' }}"
            name="textMessage"
            (keydown)="handleKeyDown($event)"
            [disabled]="loadingConversation"
            rows="1"
            #messageTextarea
            (input)="adjustTextareaHeight(messageTextarea)"
          ></textarea>
          <div class="absolute top-1/2 -translate-y-1/2 ltr:right-8 rtl:left-4 flex gap-4">
            <button type="button" class="text-primary hover:text-dark dark:hover:text-white group" (click)="startConversation(1)">
              <icon-plus />
              <span
                class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-900 text-white text-xs rounded py-1 px-2 absolute bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-nowrap pointer-events-none"
              >
                Nuevo chat
              </span>
            </button>
            <button type="button" class="text-primary hover:text-dark dark:hover:text-white group" (click)="sendMessage()">
              <icon-send />
              <span
                class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-900 text-white text-xs rounded py-1 px-2 absolute bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-nowrap pointer-events-none"
              >
                Enviar mensaje
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<app-register-number-email [isModalOpen]="isModalOpen" (modalClosed)="onModalClosed($event)"></app-register-number-email>
